import { render } from "./HomeProductRecommend.vue?vue&type=template&id=a5fa1876"
import script from "./HomeProductRecommend.vue?vue&type=script&lang=js"
export * from "./HomeProductRecommend.vue?vue&type=script&lang=js"

import "./HomeProductRecommend.vue?vue&type=style&index=0&id=a5fa1876&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__